import styled from 'styled-components'

export const Container = styled.div`
  background-color: ${(props) => props.theme.color.neutral.white};
  border: 1px solid rgba(73, 73, 73, 0.3);
  border-radius: 0.25rem;
  padding: 0rem 0.5rem 0rem 1rem;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  max-height: 70vh;
`

export const FilterContainer = styled.div`
  width: 50%;
  max-width: 20rem;
  align-self: end;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 30px;
  > thead {
    position: sticky;
    top: 0;
    background: #fff;
    > hr {
      width: 100%;
      margin: 0;
    }
  }
  > tbody {
    tr {
      background: #fff;
      border-spacing: 1em 0.5em;
      padding: 0 2em 1em 0;
      border: 3px solid #ffffff;
    }
    th {
      background-color: #49494970;
    }
  }
`

export const TableHeader = styled.th`
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #00000020;
  font-size: ${(props) => props.theme.font.textsm};
  color: ${(props) => props.theme.color.neutral.gray};
  font-weight: 400;
  letter-spacing: 0.00938rem;
`

export const TableCell = styled.td`
  padding: 0.5rem;
  font-size: ${(props) => props.theme.font.textsm};
  background-color: #f5f5f5;
  color: #000;
`

export const TableCellEmpty = styled.td`
  padding: 0.5rem;
  font-size: ${(props) => props.theme.font.textsm};
  background-color: #f5f5f5;
  color: #000;
  text-align: center;
`

export const Search = styled.form`
  display: flex;
  padding: 1rem;
  gap: 1rem;
  align-self: flex-end;
  align-items: center;
  justify-content: flex-end;

  > span {
    font-size: ${(props) => props.theme.font.textsm};
    color: ${(props) => props.theme.color.neutral.gray};
  }
`

export const Footer = styled.footer`
  font-size: ${(props) => props.theme.font.textsm};
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 12px */
  letter-spacing: 0.048px;
  color: ${(props) => props.theme.color.neutral.gray};
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 0.5rem;
  opacity: 0.6;
`
